import React from 'react'
import { WRITING_RESOURCES } from '../components/Resources'
const English = () => {
  return (
    <div className='font-main'>
        <header className='h-52 bg-black flex items-center justify-center'>
            <h1 className='text-white text-8xl text-center w-100'>English</h1>
        </header>
        <div className='flex flex-wrap justify-evenly'>
        {WRITING_RESOURCES.map((resource) => (
                <div className='flex flex-col justify-evenly bg-black m-12 p-12 text-5xl text-center text-white w-[380px] h-[800px]'>

                <h1 className='w-[300px] '>{resource[0]}</h1>
                <div className=' flex justify-center items-center w-full'>{resource[1]}</div>
                
                <a className='' target="_blank" href={resource[2]}><button className='bg-white rounded-[50px] w-full h-fit p-4 text-black'>View</button></a>
                </div>
            ))}
        </div>
    </div>
  )
}

export default English
